// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1nnLK","boxTitle":"Qualiphy_boxTitle__2JcrM","box":"Qualiphy_box__2DRxi","toggleWrap":"Qualiphy_toggleWrap__35Ajd"};